<?xml version="1.0" encoding="UTF-8"?>
<!-- Generator: Adobe Illustrator 25.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve" width="512" height="512">
<g>
	<path d="M121.752,0C56.95,0,4.418,52.532,4.418,117.333S56.95,234.667,121.752,234.667s117.333-52.532,117.333-117.333   C239.014,52.561,186.524,0.071,121.752,0z M121.752,170.667c-29.455,0-53.333-23.878-53.333-53.333S92.296,64,121.752,64   s53.333,23.878,53.333,53.333S151.207,170.667,121.752,170.667z" fill="currentColor"/>
	<path d="M121.752,277.333c-64.801,0-117.333,52.532-117.333,117.333S56.95,512,121.752,512s117.333-52.532,117.333-117.333   C239.014,329.895,186.524,277.404,121.752,277.333z M121.752,448c-29.455,0-53.333-23.878-53.333-53.333   s23.878-53.333,53.333-53.333s53.333,23.878,53.333,53.333S151.207,448,121.752,448z" fill="currentColor"/>
	<path d="M486.253,392.832h-44.501V119.168h44.501c11.782-0.003,21.331-9.556,21.329-21.338c-0.001-5.655-2.248-11.079-6.246-15.078   L424.834,6.251c-8.331-8.328-21.835-8.328-30.165,0l-76.501,76.501c-8.33,8.332-8.328,21.84,0.005,30.17   c3.999,3.998,9.423,6.245,15.078,6.246h44.501v273.664H333.25c-11.782,0.003-21.331,9.556-21.329,21.338   c0.001,5.655,2.248,11.079,6.246,15.078l76.501,76.501c8.331,8.328,21.835,8.328,30.165,0l76.501-76.501   c8.33-8.332,8.328-21.84-0.005-30.17C497.332,395.08,491.908,392.833,486.253,392.832z" fill="currentColor"/>
</g>















</svg>
